var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("font-type")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-select", {
                    attrs: {
                      label: _vm.$ct("font-type"),
                      items: _vm.fontItems,
                      fancy: "",
                    },
                    model: {
                      value: _vm.value.DefaultFont,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "DefaultFont", $$v)
                      },
                      expression: "value.DefaultFont",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-select", {
                    attrs: {
                      label: _vm.$ct("font-size"),
                      items: _vm.fontSizes,
                      fancy: "",
                    },
                    model: {
                      value: _vm.value.DefaultFontSize,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "DefaultFontSize", $$v)
                      },
                      expression: "value.DefaultFontSize",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-color-picker", {
                    attrs: {
                      fancy: "",
                      color: _vm.value.DefaultBackgroundColor,
                      label: _vm.$ct("default-background-color"),
                    },
                    on: {
                      input: function ($event) {
                        _vm.value.DefaultBackgroundColor = $event
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-color-picker", {
                    attrs: {
                      fancy: "",
                      color: _vm.value.DefaultBorderColor,
                      label: _vm.$ct("default-border-color"),
                    },
                    on: {
                      input: function ($event) {
                        _vm.value.DefaultBorderColor = $event
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: { fancy: "", label: _vm.$ct("default-border-size") },
                    model: {
                      value: _vm.value.DefaultBorderSize,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "DefaultBorderSize", $$v)
                      },
                      expression: "value.DefaultBorderSize",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-select", {
                    attrs: {
                      label: _vm.$ct("detail-header-borders"),
                      items: _vm.headerBorderOptions,
                      fancy: "",
                    },
                    model: {
                      value: _vm.value.DetailHeaderBorders,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "DetailHeaderBorders", $$v)
                      },
                      expression: "value.DetailHeaderBorders",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }